import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopButtonAdd} from "../../../../../componentsTopsa/buttons/TopButtons";

export default class EprzystankiSelect extends Component{
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    componentDidMount(){
    }

    componentWillReceiveProps(nextprops){
        /*if(Boolean(nextprops.trasaLS)){
            this.setState({trasa:nextprops.trasaLS})
        }*/
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-default'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/></div>
    }

    onChangeSelect(e){
        this.setState({trasa:e})
        if(e !== null){
            this.props.handleSelectTrasa(e)
        }
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12} sm={6} lg={3}>
                        <TopSelect onChange={this.onChangeSelect}
                                   value={this.state.trasa}
                                   options={this.props.trasy}
                                   valueKey={'idTr'}
                                   labelKey={'nazTr'}
                                   valueRenderer={this.formatTrasaSelect}
                                   optionRenderer={this.formatTrasaSelect}
                                   placeholder={'Wybierz trasę...'}
                        />
                    </Col>
                    <Col xs={12} sm={6} lg={9}>
                        <div className={'pull-right'}>
                            <TopButtonAdd onClick={()=>this.props.handleClickPokaz()} />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/ePrzystanki/components/EprzystankiSelect.js